<template>
  <div class="system">
    <div class="topBox">
      <Button type="primary" class="basicBtn" custom-icon="iconfont icon-jia" @click="addClinic">新建科室</Button>
    </div>
    <div class="mainBox">
       <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1"></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
    <Modal 
    class="infoModal"
        :name="modelName"
        v-model="modal1"
        :title="modelTitle"
        @on-ok="ok"
        @on-cancel="cancel1">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>
    </Modal>
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modal2"
        :title="modelTitle"
        @on-ok="confirm"
        @on-cancel="cancel">
        <div class="accountBox">
          <ul>
            <li>
              <p><span class="redsize">科室名称:</span></p>
              <p>
                <Input v-model="clinicName" placeholder="科室名称" style="width: 300px" />
              </p>
            </li>
            <li>
              <p><span class="redsize">科室编码:</span></p>
              <Input v-model="clinicNo" placeholder="科室编码" style="width: 300px" />
            </li>
            <li>  
              <p><span class="redsize">排序:</span></p>
              <Input v-model="orderNum" placeholder="排序" style="width: 300px" />
            </li>
            <li>  
              <p><span class="redsize">状态:</span></p>
              <RadioGroup v-model="status" @on-change="changeSwitch(editId,status)">
                <Radio v-for="(item,index) in statusList"  v-bind:key="index" :label="item.value" >{{item.label}}</Radio>
              </RadioGroup>
            </li>
          </ul>
        </div>
        <div slot="footer">
            <Button size="large" @click="cancel">取消</Button>
            <Button type="primary" size="large" @click="confirm">确定</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import { 
  clinicList,clinicStatus,
  updCLinic,saveClinic,
  deleteClinic,clinicDetail,
  peopleStatus
} from "./../../api/system";
import { tips } from "../../tools";
export default {
  name: 'ClinicManager',
  data () {
    return {
      tableHeight:632,
      total:0,
      pageCurrent:1,
      pageSize: 10,
      deleteId:0,
      editId:0,
      modal2:false,
      modelContent:'',
      modelName:'',
      modal1:false,
      modelTitle:'',
      modeIcon:'',
      status:1,//状态
      statusList:[
        {
          label:'启用',
          value:1
        },
        {
          label:'停用',
          value:0
        }
      ],
      clinicName:'',//科室名称
      clinicNo:'',//科室编码
      orderNum:'',//排序
      iconColor:'',
      columns1:[
        {
          title: '科室名称',
          key: 'departmentName',
          align:'center'
        },
        {
          title: '科室编码',
          key: 'departmentCode',
          align:'center'
        },
        {   
          title: '排序',
          key: 'orderNum',
          align:'center'
        },
        {
            title: '状态',
            key: 'enabled',
            align:'center',
            // params.row.enabled=='1'?'已使用':'未使用' 
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps:{
                innerHTML:params.row.enabled=='1'?'已启用':'未启用' 
              }
            },
            // [
            //   h('i-switch',{
            //     props:{
            //       custom:'iconfont icon-duihao',
            //       value:params.row.enabled==1?true:false 
            //     },
            //     style:{
            //       textAlign:'center'
            //     },
            //     on:{
            //       'on-change': (value) => {
            //         console.log(value)
            //         let id = params.row.id;
            //         let enabled = 0;
            //         switch(value){
            //           case true:
            //             enabled = 1;
            //             break;
            //           case false:
            //             enabled = 0;
            //         }
            //         this.changeSwitch(id,enabled);
            //       }
            //     }
            //   })
            // ]
            )
          }
        },
        {
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-bianji'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.modelName = 'editClinic';
                      this.modelTitle = '修改科室';
                      this.clinicName = '';
                      this.clinicNo = '';
                      this.orderNum = 0;
                      console.log(params.row.id);
                      let queId = params.row.id;
                      this.editId = queId;
                      this.clinicDetail();
                    }
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shanchu'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:'#C9C9C9',
                    color:'#595757'
                  },
                  on: {
                    click: () => {
                      this.modal1 = true;
                      this.modelName = 'delete';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否确认删除该科室?此操作不可逆';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#FE6E6E';
                      let queId = params.row.id;
                      this.deleteId = queId;
                    }
                  }
                }, '删除'),
            ]);
          }
        }
      ],
      data1:[
        {
          clinicName: '全科',
          clinicMember: '陈秀珍'
        },
      ]
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-90; 
    },
    //查询科室
    loadList(){
      let _this = this;
      clinicList({
        current: _this.pageCurrent,
        size: _this.pageSize
      }).then(res => {
        console.log(res)
        _this.data1 = res.records;
        _this.total = res.total;
      });
    },
    //新建科室
    addClinic(){
      this.modal2 = true;
      this.modelName = 'newClinic';
      this.modelTitle = '新增科室';
      this.clinicName = '';
      this.clinicNo = '';
      this.orderNum = 0;
    },
    clinicDetail(){
      let _this = this;

      clinicDetail({
        id:_this.editId
      }).then(res => {
        console.log(res);
        _this.clinicName = res.departmentName;
        _this.clinicNo = res.departmentCode;
        _this.editId = res.id;
        _this.orderNum = res.orderNum;
        _this.status = res.enabled;
      });
    },
    confirm(){
      let _this = this;
      switch(this.modelName){
        case 'newClinic':
          saveClinic({
            code:_this.clinicNo,
            name: _this.clinicName,
            orderNum: _this.orderNum
          }).then(res => {
            console.log(res);
            tips(_this, res, "success");
            _this.modal2 = false;
            _this.loadList();
          });
          break;
        case 'editClinic':
          updCLinic({
            id:_this.editId,
            code:_this.clinicNo,
            name: _this.clinicName,
            orderNum: _this.orderNum
          }).then(res => {
            console.log(res);
            tips(_this, res, "success");
            _this.modal2 = false;
            _this.loadList();
          });
          break;
      }
    },
    ok(){
      let _this = this;
      deleteClinic({
        id:_this.editId
      })(res => {
        console.log(res);
        tips(_this, res, "success");
        _this.modal1 = false;
        _this.loadList();
      });
    },
    cancel1(){
      this.modal1 = false;
    },
    cancel(){
      this.modal2 = false;
    },
    changeSwitch(id,enabled){
      console.log(id,enabled);
      clinicStatus({
        id:id,
        enabled:enabled
      }).then(res => {
        console.log(res);
        tips(this, res, "success");
      });
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.system{
  height: 100%;
  padding: 10px;
}
.topBox{
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
  padding-bottom:10px;
}
.topBox>p{
  font-size: 14px;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-modal-body p{
  font-size: 14px;
}
/* 新建账户框 */
.accountBox>ul>li{
  display: flex;
  justify-content: baseline;

}
.accountBox>ul>li>p:first-child{
  width: 150px;
  height: 41px;
  padding: 10px;
}
.accountBox>ul>li>p>span.block{
  display: block;
  color: #FE6E6E;
}
.accountBox>ul>li>div{
  padding: 5px 0;
}
.accountBox>ul>li>p>span.redsize{
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/ClinicManager.vue